import { Controller } from '@hotwired/stimulus';
import Clipboard from "clipboard";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        source: String,
        successText: String,
    };

    static targets = [
        'button',
        'source',
        'success',
    ];

    clipboard = null;

    timeout = null;

    connect() {
        const options = {};

        if (this.hasSourceTarget) {
            options.target = () => {
                return this.sourceTarget;
            };
        } else {
            options.text = (trigger) => {
                return this.sourceValue;
            };
        }

        this.clipboard = new Clipboard(this.buttonTarget, options);

        if (this.hasSuccessTextValue || this.hasSuccessTarget) {
            this.clipboard.on('success', () => {
                if (this.hasSuccessTarget) {
                    this.successTarget.classList.add('show');
                    this.successTarget.classList.remove('d-none');
                    this.successTarget.innerText = this.successTextValue;

                    clearTimeout(this.timeout);

                    this.timeout = setTimeout(() => {
                        this.successTarget.classList.remove('show');
                        this.successTarget.classList.add('d-none');
                        this.successTarget.innerText = '';
                    }, 3000);
                } else {
                    addAlert('success', this.successTextValue);
                }
            });
        }
    }

    disconnect() {
        this.clipboard.destroy();
    }
}
